var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBaking = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Cake-Cherry--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Cake Cherry Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15h23a0.5 0.5 0 0 0 0.34 -0.87L17.16 8a0.24 0.24 0 0 0 -0.23 -0.06 0.23 0.23 0 0 0 -0.17 0.16A5 5 0 0 1 7 6.49a4.89 4.89 0 0 1 0.4 -1.95 0.26 0.26 0 0 0 -0.07 -0.29 0.26 0.26 0 0 0 -0.29 0C3.91 6 0 9.27 0 14.5a0.5 0.5 0 0 0 0.5 0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.48A3 3 0 0 0 13.68 4a0.53 0.53 0 0 1 -0.22 -0.33 0.52 0.52 0 0 1 0.09 -0.38A3.27 3.27 0 0 1 15.66 2a1 1 0 0 0 0.82 -1.16A1 1 0 0 0 15.31 0a5.22 5.22 0 0 0 -4 3.19 1 1 0 0 1 -0.52 0.54A3 3 0 0 0 12 9.48Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 21H0.5a0.5 0.5 0 0 0 -0.5 0.5v0.5a2 2 0 0 0 2 2h20a2 2 0 0 0 2 -2v-0.5a0.5 0.5 0 0 0 -0.5 -0.5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 16.5h23s0.5 0 0.5 0.5v2s0 0.5 -0.5 0.5H0.5s-0.5 0 -0.5 -0.5v-2s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBaking);
export default ForwardRef;